const footerCodes = [
  {
    id: 'Index',
    code: 'shouye'
  },
  {
    id: 'Supplier',
    code: 'gongyingshan'
  },
  {
    id: 'Purchase',
    code: 'caigou'
  },
  {
    id: 'PurchaseManage',
    code: 'caigouxunyuan'
  },
  {
    id: 'Law',
    code: 'fawu'
  },
  {
    id: 'ContractManage',
    code: 'hetong'
  },
  {
    id: 'SrmCloud',
    code: 'srm'
  },
  {
    id: 'Einvoice',
    code: 'dianzifapiao'
  },
  {
    id: 'Finance',
    code: 'caiwu'
  },
  {
    id: 'System',
    code: 'xitongjicheng'
  },
  {
    id: 'EcDeal',
    code: 'dianshancuohe'
  },
  {
    id: 'Bidding',
    code: 'zhaotoubiao'
  },
  {
    id: 'Integration',
    code: 'pingtaijicheng'
  },
  {
    id: 'PurchaseCoordination',
    code: 'caigouxietong'
  },
  {
    id: 'CooperativePartner',
    code: 'hezuohuoban'
  }, {
    id: 'ServiceSupport',
    code: 'fuwuzhichi'
  },
  {
    id: 'Company',
    code: 'gongsi'
  },
  {
    id: 'CompanyDetail',
    code: 'gongsixiangqing'
  },
  {
    id: 'AboutUs',
    code: 'guangyuwomen'
  },
  {
    id: 'Clientele',
    code: 'kehuanli'
  },
  {
    id: 'ClienteleDetile',
    code: 'kehuanli-xiangqing'
  },
  {
    id: 'DataDownload',
    code: 'xiazai'
  },
  {
    id: 'DataDownloadDetail',
    code: 'xiazaixiangqing'
  },
  {
    id: 'Solution',
    code: 'jiejuefangan'
  },
  {
    id: 'Industry',
    code: 'jiejuefangan-zhuyemian'
  }
]
export default footerCodes



//////////////////
// WEBPACK FOOTER
// ./static/js/staticFooterCode.js
// module id = 363
// module chunks = 12